module.exports = __webpack_public_path__ + "img/phone-proposition.ab167a23.webp";